/*
  Shared "ends at midnight in Sydney" countdown.
  One implementation, used by the PDP offer bar and by the cart drawer, so the
  two can never drift apart. The time is derived from the viewer's clock and
  converted to Australia/Sydney with Intl, so daylight saving is handled for us.

  A single ticker paints every [data-au-countdown] currently in the page. That
  matters because the cart drawer is re-rendered through the sections API on
  every cart change: a per-element timer would die with the old markup, while
  this one simply finds whatever is on the page a second later.

  An element carrying data-compact gets 03:11:09 instead of 03 : 11 : 09, which
  is what the compact PDP offer bar wants.
*/
(function () {
  if (window.AuCountdown) return;

  var TZ = 'Australia/Sydney';

  function secondsLeft() {
    var parts = {};
    new Intl.DateTimeFormat('en-AU', {
      timeZone: TZ,
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
      .formatToParts(new Date())
      .forEach(function (p) {
        if (p.type !== 'literal') parts[p.type] = parseInt(p.value, 10);
      });
    var h = parts.hour === 24 ? 0 : parts.hour || 0;
    var left = 86400 - (h * 3600 + (parts.minute || 0) * 60 + (parts.second || 0));
    // At 00:00:00 the arithmetic gives a full day; the clock should read 23:59:59
    // and start falling again, not flash 24 : 00 : 00 for a second.
    return left >= 86400 ? 86399 : left;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function format(total) {
    if (!(total > 0)) total = 0;
    return pad(Math.floor(total / 3600)) + ' : ' + pad(Math.floor((total % 3600) / 60)) + ' : ' + pad(total % 60);
  }

  function paint() {
    var full = format(secondsLeft());
    var compact = full.replace(/ /g, '');
    var nodes = document.querySelectorAll('[data-au-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      var text = nodes[i].hasAttribute('data-compact') ? compact : full;
      var out = nodes[i].querySelector('[data-au-countdown-value]') || nodes[i];
      if (out.textContent !== text) out.textContent = text;
    }
  }

  /* ----------------------------------------------------------------------
     Dispatch cutoff and estimated delivery.
     Same Sydney clock as the offer countdown. "Order within" counts down to
     the next dispatch cutoff on a business day; the estimated date is that
     dispatch day plus N business days. Weekends are skipped on both sides.
     ---------------------------------------------------------------------- */

  function sydneyNow() {
    var p = {};
    new Intl.DateTimeFormat('en-AU', {
      timeZone: TZ, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date()).forEach(function (x) {
      if (x.type !== 'literal') p[x.type] = parseInt(x.value, 10);
    });
    if (p.hour === 24) p.hour = 0;
    return p;
  }

  // Calendar days are anchored at noon UTC so stepping a day never trips over
  // a daylight-saving boundary.
  function dayOf(p) {
    return new Date(Date.UTC(p.year, p.month - 1, p.day, 12, 0, 0));
  }

  // skipWeekends off means the courier counts every day, so every day ships.
  function isBusiness(d, skipWeekends) {
    if (!skipWeekends) return true;
    var g = d.getUTCDay();
    return g >= 1 && g <= 5;
  }

  function addBusinessDays(d, n, skipWeekends) {
    var c = new Date(d.getTime());
    while (n > 0) {
      c.setUTCDate(c.getUTCDate() + 1);
      if (isBusiness(c, skipWeekends)) n--;
    }
    return c;
  }

  /*
    "3 to 5 business days" is counted from the day the order is placed: the next
    business day is day one, so an order on Sunday the 13th lands Wednesday the
    16th at the earliest and Friday the 18th at the latest. Saturday and Sunday
    are never counted, on either side. Nothing here is stored, so the whole thing
    recomputes itself the moment the Sydney date rolls over at midnight.

    The cut-off only decides which day counts as the order day. At the default of
    24 that is simply the current Sydney date, which is why the countdown to
    midnight and the delivery window turn over together.
  */
  function shipState(cutoffHour, businessDays, skipWeekends, minDays) {
    if (skipWeekends === undefined) skipWeekends = true;
    var p = sydneyNow();
    var today = dayOf(p);
    var nowSecs = p.hour * 3600 + p.minute * 60 + p.second;
    var cutoffSecs = cutoffHour * 3600;
    var placed, left;

    if (nowSecs < cutoffSecs) {
      placed = today;
      left = cutoffSecs - nowSecs;
    } else {
      // Past today's cut-off, so the order counts as placed tomorrow.
      placed = new Date(today.getTime());
      placed.setUTCDate(placed.getUTCDate() + 1);
      left = 86400 - nowSecs + cutoffSecs;
    }
    if (minDays === undefined || minDays > businessDays) minDays = businessDays;
    return {
      secondsLeft: left,
      eta: addBusinessDays(placed, businessDays, skipWeekends),
      etaEarliest: addBusinessDays(placed, minDays, skipWeekends)
    };
  }

  var etaFormat = new Intl.DateTimeFormat('en-AU', {
    timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
  });

  // en-AU renders "Friday 25 September"; the block reads better with the comma.
  function etaText(d) {
    var o = {};
    etaFormat.formatToParts(d).forEach(function (x) {
      if (x.type !== 'literal') o[x.type] = x.value;
    });
    if (!o.weekday) return etaFormat.format(d);
    // "Monday 21 September": the label beside it already says what the date is for.
    return o.weekday + ' ' + o.day + ' ' + o.month;
  }

  // The compact PDP line wants the window, not a weekday: "21–25 September".
  var dayMonth = new Intl.DateTimeFormat('en-AU', { timeZone: 'UTC', day: 'numeric', month: 'long' });
  function dayMonthParts(d) {
    var o = {};
    dayMonth.formatToParts(d).forEach(function (x) { if (x.type !== 'literal') o[x.type] = x.value; });
    return o;
  }
  function rangeText(a, b) {
    var A = dayMonthParts(a), B = dayMonthParts(b);
    if (!A.day || !B.day) return dayMonth.format(b);
    if (a.getTime() === b.getTime()) return A.day + ' ' + A.month;
    if (A.month === B.month) return A.day + '–' + B.day + ' ' + B.month;
    return A.day + ' ' + A.month + ' – ' + B.day + ' ' + B.month;
  }

  // "Wed 16 - Fri 18 Sep": a window, because 3 to 5 business days is not a promise
  // of one date. Weekday and month come from en-AU, so the wording stays Australian.
  var shortFmt = new Intl.DateTimeFormat('en-AU', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
  function shortParts(d) {
    var o = {};
    shortFmt.formatToParts(d).forEach(function (x) { if (x.type !== 'literal') o[x.type] = x.value; });
    return o;
  }
  function shortRange(a, b) {
    var A = shortParts(a), B = shortParts(b);
    if (!A.day || !B.day) return shortFmt.format(b);
    if (a.getTime() === b.getTime()) return A.weekday + ' ' + A.day + ' ' + A.month;
    if (A.month === B.month) return A.weekday + ' ' + A.day + ' – ' + B.weekday + ' ' + B.day + ' ' + B.month;
    return A.weekday + ' ' + A.day + ' ' + A.month + ' – ' + B.weekday + ' ' + B.day + ' ' + B.month;
  }

  function readShipAttrs(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    var days = parseInt(el.getAttribute('data-days-max') || el.getAttribute('data-days'), 10);
    var minDays = parseInt(el.getAttribute('data-days-min'), 10);
    if (isNaN(cutoff)) cutoff = 24;
    if (isNaN(days)) days = 5;
    if (isNaN(minDays) || minDays > days) minDays = days;
    // The standard service is a five-business-day promise; never quote longer.
    if (days > 5) days = 5;
    if (minDays > days) minDays = days;
    return { cutoff: cutoff, days: days, minDays: minDays, skip: el.getAttribute('data-weekends') !== 'include' };
  }

  function paintShip() {
    var nodes = document.querySelectorAll('[data-au-ship]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var a = readShipAttrs(el);
      var st = shipState(a.cutoff, a.days, a.skip, a.minDays);
      var t = el.querySelector('[data-au-ship-timer]');
      var d = el.querySelector('[data-au-ship-date]');
      // One clock for the whole store: "Order within" counts down to midnight
      // in Sydney, the same seconds the offer bar and the cart drawer show,
      // so the three can never disagree. Nothing is stored between ticks, so a
      // refresh lands on the same second and midnight simply rolls it over.
      if (t) {
        var text = format(secondsLeft());
        if (t.textContent !== text) t.textContent = text;
      }
      var rg = el.querySelector('[data-au-ship-range]');
      if (rg) {
        var window_ = shortRange(st.etaEarliest, st.eta);
        if (rg.textContent !== window_) rg.textContent = window_;
      }
      if (d) {
        var date = etaText(st.eta);
        if (d.textContent !== date) d.textContent = date;
        // The visible value stays the later date; the window goes in the title
        // so the earliest day is still available without crowding the block.
        var title = st.etaEarliest.getTime() === st.eta.getTime()
          ? 'Arriving ' + date
          : 'Arriving between ' + etaText(st.etaEarliest) + ' and ' + date;
        if (d.getAttribute('title') !== title) d.setAttribute('title', title);
      }
    }
  }

  // The one-line version under the CTA: "Order today · Estimated delivery 16–18 September".
  function paintShipLine() {
    var nodes = document.querySelectorAll('[data-au-shipline]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var a = readShipAttrs(el);
      var st = shipState(a.cutoff, a.days, a.skip, a.minDays);
      var out = el.querySelector('[data-au-shipline-date]');
      if (!out) continue;
      var text = rangeText(st.etaEarliest, st.eta);
      if (out.textContent !== text) out.textContent = text;
    }
  }

  window.AuCountdown = { secondsLeft: secondsLeft, format: format, paint: paint, paintShip: paintShip, paintShipLine: paintShipLine, shipState: shipState, shortRange: shortRange };

  function tick() { paint(); paintShip(); paintShipLine(); }
  setInterval(tick, 1000);
  tick();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick);

  // Paint straight away when new markup lands, so a freshly rendered drawer
  // never shows the 00 : 00 : 00 placeholder even for a moment.
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          tick();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
